"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_hook_form_1 = require("react-hook-form");
const react_number_format_1 = __importDefault(require("react-number-format"));
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/common/components");
const string_utils_1 = require("@/common/string_utils");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ control, isFeeFree, errors }) {
    const defaultConditionArr = (0, react_redux_1.useSelector)((state) => state.conditionalDeliveries[0]);
    const defaultCondition = (defaultConditionArr === null || defaultConditionArr === void 0 ? void 0 : defaultConditionArr.number) || '';
    const defaultConditionalPrice = (defaultConditionArr === null || defaultConditionArr === void 0 ? void 0 : defaultConditionArr.origin_price) || '';
    const { t } = (0, react_i18next_1.useTranslation)();
    const { field: { onChange: onConditionChange, value: conditionValue }, } = (0, react_hook_form_1.useController)({
        name: 'condition',
        control,
        rules: { required: `${t('무료배송이 가능한 금액을 입력해주세요')}` },
        defaultValue: defaultCondition,
    }); // ? ConditionDiv의 NumberInput에 사용하는 Hooks
    const dispatch = (0, react_redux_1.useDispatch)();
    const onConditionBlur = (conditionInput) => {
        dispatch((0, roomCreateStore_1.modifyConditional)({ number: conditionInput }));
    };
    const onConditionalPriceBlur = (conditionalPriceInput) => {
        dispatch((0, roomCreateStore_1.modifyConditional)({ origin_price: conditionalPriceInput }));
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '4px' } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', alignItems: 'center', columnGap: '10px' } }, { children: [(0, jsx_runtime_1.jsx)(react_number_format_1.default, { css: {
                                    width: '60%',
                                    height: '40px',
                                    padding: '0 13px',
                                    borderRadius: '8px',
                                    border: '1px solid var(--gray-10)',
                                    ':focus': {
                                        border: '1px solid var(--gray-60)',
                                    },
                                    color: 'var(--gray-80)',
                                }, allowNegative: false, isAllowed: ({ value }) => Number(value) <= 99999999, decimalScale: 0, value: conditionValue, onValueChange: e => {
                                    onConditionChange(Number(e.value) || '');
                                }, thousandSeparator: true, placeholder: "0", autoComplete: "off", pattern: "\\d*", onBlur: (e) => onConditionBlur((0, string_utils_1.numberOnly)(e.target.value)) }, `conditional_${defaultCondition}`), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: t('원 이상 무료 배송') }))] })), errors.condition && ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1 error-dark" }, { children: errors.condition.message })))] })), (0, jsx_runtime_1.jsx)(components_1.Divider, {}), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "delivery_fee_title_input" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "delivery_fee_title body2 gray-40" }, { children: t('기본 배송비') })), (0, jsx_runtime_1.jsx)(components_1.PriceCalculator, { name: "conditional_price", control: control, defaultValue: defaultConditionalPrice, onBlurFunc: onConditionalPriceBlur, isFeeFree: isFeeFree, required: `${t('배송비를 입력해주세요')}`, isDelivery: true }), errors.conditional_price && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1 error-dark" }, { children: errors.conditional_price.message }))] }))] }))] }));
}
exports.default = default_1;
const ConditionDiv = styled_1.default.div `
  display: flex;
  align-items: center;
  column-gap: 10px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.8);
  input {
    width: 60%;
    height: 40px;
    padding: 7px 8px;
    border: 1px solid var(--gray-10);
    border-radius: 8px;
    :focus {
      border: 1px solid var(--gray-60);
    }
  }
`;
